import React from "react"
import {FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import FieldMultiselect from "../../multiselect";

// const debug = "FieldItemModelStoryPointsCalculated_TableCell"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

type Props = FieldEditableProps & {

    renderValue         : func
    renderValueHovered   : func
}

export default class FieldMultiselect_Editable extends React.Component<Props, State> {

    constructor(props:Props) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    onMouseEnter = () => {
// return
        if (!this.props.field.canEdit(this.props.model)) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
// return
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onClick = () => {
        if (!this.props.field.canEdit(this.props.model)) return

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    get classes():string {

        const classes = Classes("ui5-field-editable multiselect", this.props.className, {
            // "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            // "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onValueChange(value:any, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        this.props.onChange && this.props.onChange(value)
    }

    onResetValueClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        this.onValueChange(null)
    }

    onOptionClick = (option:Option) => {
        const field     = this.props.field as any as FieldMultiselect
        // const newValue  = field.addValue(this.props.model, option.value)
        const newValue  = field.toggleValue(this.props.model, option.value)
        this.onValueChange(newValue, false)
    }

    onDeleteOption = (option:Option) => {
        const field     = this.props.field as any as FieldMultiselect
        const newValue  = field.removeValue(this.props.model, option.value)
        this.onValueChange(newValue)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }



    renderValue = () => {

        const field = this.props.field as any as FieldMultiselect

        const value = field.getViewValue(this.props.model)

        if (_.isEmpty(value)) return false; // value = array (!)

        const valueOptions   = field._getOptions(value)

        if (!valueOptions) return false;

        let optionsToShow   = valueOptions.length;
        let moreOptions     = 0;

        debug && console.log(debug, "optionsToShow", optionsToShow, "moreOptions=", moreOptions)

        // return <div>Value here</div>

        // marginRight 32px - reserve space for buttons

        return (
            <div className="multiselect-container" style={{marginRight: '26px'}}>
                {_.map(valueOptions, (option, key) => {
                    if (key >= optionsToShow) return;

                    return <field.components.Pill key={option.value}
                                                  style={{maxWidth: field.pillMaxWidth}}
                                                  className="m-r-10" option={option} />

                })}

                {(moreOptions > 0) && <div className="ui5-link-small">{"+{0}".f(moreOptions)}</div>}
            </div>
        );


    }

    renderValueHovered = () => {

        const field = this.props.field as any as FieldMultiselect

        const value = field.getViewValue(this.props.model)

        if (_.isEmpty(value)) {
            return <div className="ui5-color-no-accent">{this.props.field.placeholder}</div>
        }

        const valueOptions   = field._getOptions(value)

        // div is required becasue of flex
        return (
            <div className="multiselect-container">
                {_.map(valueOptions, option => {
                    return <field.components.Pill key={option.value}
                                                  style={{maxWidth: field.pillMaxWidth}}
                                                  className="m-r-10" option={option} onDelete={this.onDeleteOption}/>
                })}
            </div>
        )
    }

    renderHovered() {

        const field : FieldMultiselect     = this.props.field as any as FieldMultiselect

        const classes = Classes("ui5-field-editable is-hovered ", this.props.className, {
            "multiselect"                   : !field.isEmpty(this.props.model),
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })

        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    {this.renderValueHovered()}

                    <div className="buttons flex-no-shrink">
                        <div className="btn-arrow"/>
                    </div>
                </div>
                {this.state.showPopover &&
                    <field.components.PopoverMenu {...this.props} parent={this} />
                }
            </React.Fragment>
        )
    }

    renderNotHovered() {

        return (
            <React.Fragment>
                <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                    {this.renderValue()}

                </div>
            </React.Fragment>
        )

    }

    render() {

        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)
            return this.renderHovered()
        else
            return this.renderNotHovered()

    }

}

